<template>
  <div class="cinema">

    <!-- OPENING SCREEN -->
    <div v-if="!videoActive" class="opening">
      <div class="grid"></div>

      <!-- RADAR -->
      <div class="radar"></div>

      <!-- RINGS -->
      <div class="rings">
        <div v-for="i in 8" :key="i" :class="'ring ring-'+i"></div>
      </div>

      <!-- CONTENT -->
      <div class="opening-content">
        <img src="@/assets/logo-konsel.png" class="logo" />
        <h1>LAYANAN DARURAT <span>112</span></h1>
        <!-- <p>KABUPATEN KONAWE SELATAN</p> -->

        <!-- FULLSCREEN BUTTON -->
        <button class="fs-btn" @click="enterFullscreen">
          KABUPATEN KONAWE SELATAN
        </button>
      </div>
    </div>

    <!-- BLACK FADE -->
    <div class="blackout" v-show="blackout"></div>

    <!-- SHUTTER -->
    <div class="shutter" v-show="shutterActive">
      <div class="shutter-top" :class="{ open: shutterOpen }"></div>
      <div class="shutter-bottom" :class="{ open: shutterOpen }"></div>
    </div>

    <!-- VIDEO -->
    <video
      v-show="videoActive"
      ref="video"
      class="video"
      src="@/assets/video.mp4"
      playsinline
      preload="auto"
      @loadeddata="videoReady = true"
    ></video>

    <!-- HUD -->
    <!-- <div class="hud" v-if="videoActive">
      <div>STATUS : ACTIVE</div>
      <div>CHANNEL : 112</div>
      <div>MODE : COMMAND CENTER</div>
    </div> -->

  </div>
</template>

<script>
import { db } from "../../firebase";
import { ref, onValue, update } from "firebase/database";

export default {
  data() {
    return {
      videoReady: false,
      triggered: false,

      blackout: false,
      shutterActive: false,
      shutterOpen: false,
      videoActive: false
    };
  },

  mounted() {
    onValue(ref(db, "videoTrigger"), snap => {
      if (snap.val()?.play && !this.triggered) {
        this.triggered = true;
        if (this.videoReady) this.startCinematic();
      }
    });
  },

  watch: {
    videoReady(v) {
      if (v && this.triggered) this.startCinematic();
    }
  },

  methods: {
    enterFullscreen() {
      const el = document.documentElement;
      if (el.requestFullscreen) el.requestFullscreen();
    },

    startCinematic() {
  if (this._running) return;
  this._running = true;

  update(ref(db, "videoTrigger"), {
    play: false,
    at: Date.now()
  });

  // 1. Fade to black (singkat)
  this.blackout = true;

  // 2. Aktifkan shutter
  setTimeout(() => {
    this.shutterActive = true;
  }, 300);

  // 3. Buka shutter perlahan
  setTimeout(() => {
    this.shutterOpen = true;
  }, 700);

  // 4. Munculkan video + play + fade audio
  setTimeout(() => {
    this.blackout = false;
    this.videoActive = true;

    const v = this.$refs.video;
    if (!v) return;

    // 🔊 AKTIFKAN AUDIO (INI POSISI YANG BENAR)
    v.muted = false;
    v.volume = 0;

    v.play().then(() => {
      // 🎚️ FADE IN AUDIO
      let vol = 0;
      const fade = setInterval(() => {
        vol += 0.05;
        if (vol >= 1) {
          v.volume = 1;
          clearInterval(fade);
        } else {
          v.volume = vol;
        }
      }, 80);
    }).catch(err => {
      console.warn("Autoplay blocked:", err);
    });

  }, 1200);
}


  }
};
</script>

<style scoped>
/* ROOT */
.cinema {
  position: fixed;
  inset: 0;
  background: #020817;
  overflow: hidden;
}

/* ================= OPENING ================= */
.opening {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* GRID */
.grid {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(rgba(0,224,255,.15) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0,224,255,.15) 1px, transparent 1px);
  background-size: 60px 60px;
  animation: gridMove 20s linear infinite;
  opacity: .25;
}

/* RADAR */
.radar {
  position: absolute;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  border: 2px solid rgba(0,224,255,.2);
  animation: radarPulse 4s infinite;
}

/* RINGS */
.rings {
  position: absolute;
  inset: -30%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.ring {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(0,224,255,.15);
}

.ring-1 { width:300px;height:300px;animation:spinCW 20s linear infinite; }
.ring-2 { width:420px;height:420px;opacity:.4;animation:spinCCW 28s linear infinite; }
.ring-3 { width:580px;height:580px;border-style:dashed;animation:spinCW 40s linear infinite; }
.ring-4 { width:760px;height:760px;opacity:.25;animation:spinCCW 55s linear infinite; }
.ring-5 { width:980px;height:980px;border-style:dotted;opacity:.18;animation:spinCW 75s linear infinite; }
.ring-6 { width:1200px;height:1200px;opacity:.12;animation:spinCCW 95s linear infinite; }
.ring-7 { width:1500px;height:1500px;opacity:.08;animation:spinCW 140s linear infinite; }
.ring-8 { width:1800px;height:1800px;opacity:.05;animation:spinCCW 200s linear infinite; }

/* CONTENT */
.opening-content {
  text-align: center;
  z-index: 3;
  color: #c7dcff;
  animation: fadeUp 2s ease forwards;
}

.logo {
  width: 120px;
  margin-bottom: 18px;
}

h1 {
  font-size: 26px;
  letter-spacing: 2px;
}
h1 span {
  color: #00e0ff;
  font-size: 36px;
}

p {
  margin-top: 6px;
  letter-spacing: 1.5px;
  font-size: 14px;
  opacity: .85;
}

/* FULLSCREEN BUTTON */
.fs-btn {
  /* margin-top: 28px; */
  padding: 15px 30px;
  background: transparent;
  border: 1px solid #00e0ff;
  color: #00e0ff;
  letter-spacing: 2px;
  cursor: pointer;
  transition:.3s;
}
.fs-btn:hover {
  background:#00e0ff;
  color:#020817;
}

/* ================= CINEMATIC ================= */
.blackout {
  position: absolute;
  inset: 0;
  background: black;
  z-index: 10;
}

/* SHUTTER */
.shutter {
  position: absolute;
  inset: 0;
  z-index: 11;
}
.shutter-top,
.shutter-bottom {
  position: absolute;
  width: 100%;
  height: 50%;
  background: black;
  transition: transform 2.5s cubic-bezier(.7,0,.3,1);
}
.shutter-top { top:0; }
.shutter-bottom { bottom:0; }

.shutter-top.open { transform: translateY(-100%); }
.shutter-bottom.open { transform: translateY(100%); }

/* VIDEO */
.video {
  position: absolute;
  inset: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  object-fit: cover;
  animation: cinematicZoom 18s linear forwards;
}

/* HUD */
.hud {
  position: absolute;
  top: 24px;
  left: 24px;
  z-index: 12;
  color: #00e0ff;
  font-family: monospace;
  letter-spacing: 2px;
  text-shadow: 0 0 10px rgba(0,224,255,.6);
}

/* ================= ANIMATIONS ================= */
@keyframes gridMove {
  from { background-position:0 0; }
  to { background-position:60px 60px; }
}
@keyframes radarPulse {
  0% { transform:scale(.7);opacity:.1 }
  70% { transform:scale(1.2);opacity:.35 }
  100% { opacity:0 }
}
@keyframes spinCW {
  from { transform:rotate(0) }
  to { transform:rotate(360deg) }
}
@keyframes spinCCW {
  from { transform:rotate(360deg) }
  to { transform:rotate(0deg) }
}
@keyframes fadeUp {
  from { opacity:0; transform:translateY(14px) }
  to { opacity:1; transform:none }
}
@keyframes cinematicZoom {
  to { transform:scale(1.15) }
}
</style>
